<template>
  <div class="order-detail-container">
    <div class="header">
      <h2>订单详情（{{ orderStatusText }}）</h2>
    </div>

    <div class="action-bar">
      <el-button
        v-if="orderDetail.orderStatus === '待发货'"
        @click="handleCancelOrder"
        class="action-btn"
      >
        取消订单
      </el-button>

      <el-button
        v-if="orderDetail.orderStatus === '待发货'"
        type="primary"
        @click="handleDelivery"
        class="action-btn"
      >
        立即发货
      </el-button>

      <!-- 待收货状态下的按钮 -->
      <el-button
        v-if="orderDetail.orderStatus === '待收货'"
        @click="handleCancelOrder"
        class="action-btn"
      >
        取消订单
      </el-button>

      <el-button
        v-if="orderDetail.orderStatus === '待收货'"
        type="primary"
        @click="handleCompleteOrder"
        class="action-btn"
      >
        完成订单
      </el-button>
    </div>

    <div class="order-content">
      <!-- 上部分：快递单号和备注 -->
      <el-row :gutter="20" class="top-section">
        <el-col :span="12">
          <div class="info-section">
            <div class="section-header">
              <span>快递单号</span>
            </div>
            <div class="info-content vertical-layout">
              <div
                v-if="orderDetail.expressNumber"
                class="express-number-container"
              >
                <div class="express-number-line">
                  <span class="value">{{ orderDetail.expressNumber }}</span>
                  <el-button
                    type="text"
                    @click="copyExpressNumber(orderDetail.expressNumber)"
                    class="copy-btn"
                  >
                    <i class="el-icon-document-copy"></i> 复制
                  </el-button>
                </div>
                <el-button
                  type="text"
                  @click="handleFillExpress"
                  class="fill-btn"
                >
                  填写
                </el-button>
              </div>
              <el-button
                v-else
                type="text"
                @click="handleFillExpress"
                class="fill-btn"
              >
                填写
              </el-button>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="info-section">
            <div class="section-header">
              <span>备注</span>
            </div>
            <div class="info-content vertical-layout">
              <span class="remark-content" v-if="orderDetail.orderNotes">
                {{ orderDetail.orderNotes }}
              </span>
              <el-button
                type="text"
                @click="handleRemark"
                :class="['remark-btn', remarkColor]"
              >
                备注
              </el-button>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 中部分：交易信息和买家信息 -->
      <el-row :gutter="20" class="middle-section">
        <el-col :span="12">
          <div class="info-section">
            <div class="section-header">
              <span>交易信息</span>
            </div>
            <div class="info-content">
              <p>订单号码：{{ orderDetail._id }}</p>
              <p v-if="orderDetail.orderTime">
                下单时间：{{ formatDateTime(orderDetail.orderTime) }}
              </p>
              <p v-if="showDeliveryTime && orderDetail.deliveryTime">
                发货时间：{{ formatDateTime(orderDetail.deliveryTime) }}
              </p>
              <p v-if="showCompletionTime && orderDetail.orderCompletionTime">
                完成时间：{{ formatDateTime(orderDetail.orderCompletionTime) }}
              </p>
              <p v-if="showCancelTime && orderDetail.cancelTime">
                取消时间：{{ formatDateTime(orderDetail.cancelTime) }}
              </p>
            </div>
          </div>
        </el-col>
        <!-- 买家信息部分 -->
        <el-col :span="12">
          <div class="info-section">
            <div class="section-header">
              <span>买家信息</span>
              <el-button
                type="text"
                @click="toggleAddressDisplay"
                class="toggle-btn"
              >
                {{ showFullInfo ? "隐藏" : "显示" }}
              </el-button>
            </div>
            <div class="info-content">
              <p>收货地址：{{ displayAddress }}</p>
              <p>
                收货人：{{ displayReceiver }}
                {{ orderDetail.receiptInfo.recipientGender }}
              </p>
              <p>手机号：{{ displayPhone }}</p>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 下部分：商品信息 -->
      <div class="info-section bottom-section">
        <div class="section-header">
          <span
            >商品信息（数量：共{{
              orderDetail.goodsTotalQuantity
            }}件，总计：￥{{ orderDetail.totalAmount }}）</span
          >
        </div>
        <el-table :data="orderDetail.items" style="width: 100%">
          <el-table-column label="商品主图" width="120">
            <template slot-scope="scope">
              <el-image
                :src="scope.row.goodsImage"
                :preview-src-list="[scope.row.goodsImage]"
                class="goods-image"
                fit="cover"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </template>
          </el-table-column>
          <el-table-column label="商品名称" min-width="200">
            <template slot-scope="scope">
              <div>{{ scope.row.goodsName }}</div>
              <div class="goods-id">ID: {{ scope.row._id }}</div>
            </template>
          </el-table-column>
          <el-table-column label="单价" width="200">
            <template slot-scope="scope">
              ￥{{ scope.row.goodsPrice }}
            </template>
          </el-table-column>
          <el-table-column
            label="数量"
            prop="singleGoodQuantity"
            width="120"
          ></el-table-column>
        </el-table>

        <el-pagination
          v-if="orderDetail.items && orderDetail.items.length > 10"
          background
          layout="prev, pager, next"
          :total="orderDetail.items.length"
          :page-size="10"
          class="pagination"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 填写快递单号弹窗 -->
    <el-dialog
      title="填写快递单号"
      :visible.sync="expressDialogVisible"
      width="500px"
      center
    >
      <div class="express-dialog-content">
        <el-input
          v-model="expressForm.number"
          placeholder="请填写快递单号"
          clearable
          maxlength="40"
          show-word-limit
        ></el-input>
        <div class="dialog-buttons">
          <el-button @click="expressDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="confirmExpress">确定</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 备注弹窗 -->
    <el-dialog
      title="订单备注"
      :visible.sync="remarkDialogVisible"
      width="600px"
      center
    >
      <div class="remark-dialog-content">
        <!-- 正常订单标签 -->
        <div class="tag-group">
          <div class="tag-group-title">正常订单标签</div>
          <el-tag
            class="remark-tag"
            :class="{ 'tag-selected': selectedNormal }"
            @click="toggleNormalTag"
          >
            顾客已付款{{ orderDetail.totalAmount || "0" }}元
          </el-tag>
        </div>

        <!-- 问题订单标签 -->
        <div class="tag-group">
          <div class="tag-group-title">问题订单标签</div>
          <el-tag
            v-for="(tag, index) in problemTags"
            :key="index"
            class="remark-tag"
            :class="{ 'tag-selected': selectedProblemTags.includes(tag) }"
            @click="toggleProblemTag(tag)"
          >
            {{ tag }}
          </el-tag>
        </div>

        <!-- 备注内容输入 -->
        <div class="remark-input-container">
          <el-input
            type="textarea"
            :rows="4"
            v-model="remarkForm.notes"
            placeholder="请输入备注内容"
            maxlength="500"
            show-word-limit
          ></el-input>
        </div>

        <div class="dialog-buttons">
          <el-button @click="remarkDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="confirmRemark">提交</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "PCOrderDetail",
  data() {
    return {
      orderId: this.$route.params.id,
      orderDetail: {
        _id: "",
        orderStatus: "",
        expressNumber: "",
        orderNotes: "",
        orderTime: "",
        deliveryTime: "",
        orderCompletionTime: "",
        cancelTime: "",
        cancelledFrom: "",
        receiptInfo: {
          recipientName: "",
          recipientGender: "先生",
          mobileNumber: "",
          deliveryAddress: {
            address: "",
            name: "",
            houseNumber: "",
          },
        },
        items: [],
        goodsTotalQuantity: 0,
        totalAmount: 0,
      },
      showFullInfo: false,
      cancelDialogVisible: false,
      deliveryDialogVisible: false,
      completeDialogVisible: false,
      expressDialogVisible: false,
      remarkDialogVisible: false,
      expressForm: {
        number: "",
      },
      remarkForm: {
        notes: "",
        type: "default",
      },
      remarkColor: "default-remark-btn",
      // 新增数据属性
      problemTags: [
        "顾客未付款",
        "联系不到顾客",
        "找不到地址",
        "沟通不清地址",
        "顾客不要了",
        "没货了",
      ],
      selectedNormal: false,
      selectedProblemTags: [],
    };
  },
  computed: {
    orderStatusText() {
      const statusMap = {
        待发货: "待发货",
        待收货: "待收货",
        完成: "已完成",
        已取消: "已取消",
      };
      return (
        statusMap[this.orderDetail.orderStatus] || this.orderDetail.orderStatus
      );
    },
    displayAddress() {
      if (!this.orderDetail.receiptInfo.deliveryAddress) return "";

      const addr = this.orderDetail.receiptInfo.deliveryAddress;
      const fullAddress = `${addr.address}${addr.name}${addr.houseNumber}`;

      if (this.showFullInfo) {
        return fullAddress;
      } else {
        if (fullAddress.length <= 10) return fullAddress;
        return (
          fullAddress.substring(0, 10) + "*".repeat(fullAddress.length - 10)
        );
      }
    },
    displayReceiver() {
      if (!this.orderDetail.receiptInfo.recipientName) return "";
      const name = this.orderDetail.receiptInfo.recipientName;

      if (this.showFullInfo) {
        return name;
      } else {
        if (name.length <= 1) return name;
        return name.substring(0, 1) + "*".repeat(name.length - 1);
      }
    },
    displayPhone() {
      if (!this.orderDetail.receiptInfo.mobileNumber) return "";
      const phone = this.orderDetail.receiptInfo.mobileNumber;

      if (this.showFullInfo) {
        return phone;
      } else {
        if (phone.length !== 11) return phone;
        return phone.substring(0, 3) + "****" + phone.substring(7);
      }
    },
    showDeliveryTime() {
      return (
        ["待收货", "完成", "已取消"].includes(this.orderDetail.orderStatus) &&
        this.orderDetail.cancelledFrom !== "待发货"
      );
    },
    showCompletionTime() {
      return this.orderDetail.orderStatus === "完成";
    },
    showCancelTime() {
      return this.orderDetail.orderStatus === "已取消";
    },
  },
  created() {
    this.fetchOrderDetail();
  },
  methods: {
    // 获取订单详情
    async fetchOrderDetail() {
      try {
        const response = await this.$http.get(
          `/api/merchantpc/orders/${this.orderId}`
        );
        if (response.data.code === 0) {
          this.orderDetail = response.data.data;
          this.expressForm.number = this.orderDetail.expressNumber || "";
          this.remarkForm.notes = this.orderDetail.orderNotes || "";

          // 设置备注颜色
          this.setRemarkColor(this.orderDetail.orderNotes);
        } else {
          this.$message.error(response.data.message || "获取订单详情失败");
        }
      } catch (error) {
        this.$message.error("获取订单详情失败");
        console.error("获取订单详情失败:", error);
      }
    },
    // 格式化时间
    formatDateTime(dateTime) {
      if (!dateTime) return "";
      const date = new Date(dateTime);
      return `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")} ${date
        .getHours()
        .toString()
        .padStart(2, "0")}:${date
        .getMinutes()
        .toString()
        .padStart(2, "0")}:${date.getSeconds().toString().padStart(2, "0")}`;
    },

    // 取消订单
    async handleCancelOrder() {
      try {
        await this.$confirm("确认取消此订单吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });

        // 获取token
        const token = localStorage.getItem("token") || "";

        const response = await this.$http.put(
          `/api/merchantpc/orders/${this.orderId}/cancel`,
          {}, // 空请求体（保持参数位置正确）
          {
            // 添加token请求头
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data.code === 0) {
          this.$message.success("订单已取消");
          this.fetchOrderDetail(); // 刷新订单详情
        } else {
          this.$message.error(response.data.message || "取消订单失败");
        }
      } catch (error) {
        // 处理token无效/过期的情况
        if (error.response?.status === 401) {
          localStorage.removeItem("token");
          this.$router.push("/MerchantLogin");
          return;
        }

        if (error !== "cancel") {
          console.error("取消订单失败:", error);
          this.$message.error("取消订单失败");
        }
      }
    },

    // 立即发货
    async handleDelivery() {
      try {
        await this.$confirm("确认要立即发货吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });

        // 获取token
        const token = localStorage.getItem("token") || "";

        const response = await this.$http.put(
          `/api/merchantpc/orders/${this.orderId}/ship`,
          {}, // 空请求体（发货接口通常不需要额外参数）
          {
            // 添加token请求头
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data.code === 0) {
          this.$message.success("发货成功");
          this.fetchOrderDetail(); // 刷新订单详情
        } else {
          this.$message.error(response.data.message || "发货失败");
        }
      } catch (error) {
        // 处理token无效/过期的情况
        if (error.response?.status === 401) {
          localStorage.removeItem("token");
          this.$router.push("/MerchantLogin");
          return;
        }

        if (error !== "cancel") {
          console.error("发货失败:", error);
          this.$message.error("发货失败");
        }
      }
    },

    // 完成订单
    async handleCompleteOrder() {
      try {
        await this.$confirm("确认要完成此订单吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });

        // 获取token
        const token = localStorage.getItem("token") || "";

        const response = await this.$http.put(
          `/api/merchantpc/orders/${this.orderId}/complete`,
          {}, // 空请求体（根据接口需求调整）
          {
            // 添加token请求头
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data.code === 0) {
          this.$message.success("订单已完成");
          this.fetchOrderDetail(); // 刷新订单详情
        } else {
          this.$message.error(response.data.message || "完成订单失败");
        }
      } catch (error) {
        // 处理token无效/过期的情况
        if (error.response?.status === 401) {
          localStorage.removeItem("token");
          this.$router.push("/MerchantLogin");
          return;
        }

        if (error !== "cancel") {
          console.error("完成订单失败:", error);
          this.$message.error("完成订单失败");
        }
      }
    },

    // 打开快递单号弹窗
    handleFillExpress() {
      this.expressForm.number = this.orderDetail.expressNumber || "";
      this.expressDialogVisible = true;
    },
    // 提交快递单号
    async confirmExpress() {
      try {
        // 获取token
        const token = localStorage.getItem("token") || "";

        const response = await this.$http.put(
          `/api/merchantpc/orders/${this.orderId}/express`,

          {
            expressNumber: this.expressForm.number.trim(),
          },
          {
            // 添加token请求头
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data.code === 0) {
          this.$message.success("快递单号保存成功");
          this.expressDialogVisible = false;
          this.fetchOrderDetail();
        } else {
          this.$message.error(response.data.message || "提交快递单号失败");
        }
      } catch (error) {
        // 处理token无效/过期的情况
        if (error.response?.status === 401) {
          localStorage.removeItem("token");
          this.$router.push("/MerchantLogin");
        }
        this.$message.error("提交快递单号失败");
        console.error("提交快递单号失败:", error);
      }
    },
    // 复制快递单号
    copyExpressNumber(number) {
      if (!number) {
        this.$message.warning("没有快递单号可复制");
        return;
      }

      // 使用 Clipboard API 复制文本
      navigator.clipboard
        .writeText(number)
        .then(() => {
          this.$message.success("快递单号已复制到剪贴板");
        })
        .catch((err) => {
          console.error("复制失败:", err);

          // 降级方案：使用 textarea 和 execCommand
          const textArea = document.createElement("textarea");
          textArea.value = number;
          textArea.style.position = "fixed";
          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();

          try {
            const successful = document.execCommand("copy");
            if (successful) {
              this.$message.success("快递单号已复制到剪贴板");
            } else {
              this.$message.error("复制失败，请手动复制");
            }
          } catch (err) {
            this.$message.error("复制失败，请手动复制");
          }

          document.body.removeChild(textArea);
        });
    },

    // 打开备注弹窗
    handleRemark() {
      this.remarkForm.notes = this.orderDetail.orderNotes || "";
      this.parseRemarkContent(this.remarkForm.notes);
      this.remarkDialogVisible = true;
    },
    // 解析备注内容初始化标签状态
    parseRemarkContent(content) {
      this.selectedNormal = false;
      this.selectedProblemTags = [];

      if (!content) return;

      // 检查正常订单标签
      const normalPattern = /顾客已付款\d+(\.\d{1,2})?元/;
      if (normalPattern.test(content)) {
        this.selectedNormal = true;
        return;
      }

      // 检查问题订单标签
      this.problemTags.forEach((tag) => {
        if (content.includes(tag)) {
          this.selectedProblemTags.push(tag);
        }
      });
    },
    // 切换正常订单标签
    toggleNormalTag() {
      this.selectedNormal = !this.selectedNormal;
      if (this.selectedNormal) {
        this.selectedProblemTags = [];
        this.updateRemarkContent();
      }
    },
    // 切换问题订单标签
    toggleProblemTag(tag) {
      const index = this.selectedProblemTags.indexOf(tag);
      if (index > -1) {
        this.selectedProblemTags.splice(index, 1);
      } else {
        this.selectedProblemTags.push(tag);
        this.selectedNormal = false;
      }
      this.updateRemarkContent();
    },
    // 更新备注内容
    updateRemarkContent() {
      let content = "";

      if (this.selectedNormal) {
        content = `顾客已付款${this.orderDetail.totalAmount}元`;
      } else if (this.selectedProblemTags.length > 0) {
        content = this.selectedProblemTags.join("。");
      }

      this.remarkForm.notes = content;
    },
    // 设置备注按钮颜色
    setRemarkColor(notes) {
      if (!notes) {
        this.remarkColor = "default-remark-btn";
        return;
      }

      // 定义匹配规则
      const normalTagPattern = /顾客已付款\d+(\.\d{1,2})?元/;
      const problemTags = [
        "顾客未付款",
        "联系不到顾客",
        "找不到地址",
        "沟通不清地址",
        "顾客不要了",
        "没货了",
      ];

      // 检查备注内容
      const hasNormalTag = normalTagPattern.test(notes);
      const hasProblemTag = problemTags.some((tag) => notes.includes(tag));

      // 设置对应颜色
      if (hasNormalTag) {
        this.remarkColor = "green-remark-btn";
      } else if (hasProblemTag) {
        this.remarkColor = "red-remark-btn";
      } else {
        this.remarkColor = "default-remark-btn";
      }
    },
    // 提交备注
    async confirmRemark() {
      try {
        // 检查正常订单和问题订单标签是否同时存在（互斥）
        if (this.selectedNormal && this.selectedProblemTags.length > 0) {
          this.$message.error("正常订单和问题订单标签不能同时选择");
          return;
        }

        // 1. 从localStorage获取Token（与项目现有认证逻辑保持一致）
        const token = localStorage.getItem("token") || "";

        // 修复URL路径和参数名
        const response = await this.$http.put(
          `/api/merchantpc/orders/${this.orderId}/remark`,
          {
            remarkContent: this.remarkForm.notes, // 使用后端期望的参数名
          },
          {
            // 2. 在请求头中携带Token，格式为标准Bearer Token
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data.code === 0) {
          this.$message.success("备注保存成功");
          this.remarkDialogVisible = false;

          // 根据选择的订单类型设置备注按钮颜色
          if (this.selectedNormal) {
            this.remarkColor = "green-remark-btn";
          } else if (this.selectedProblemTags.length > 0) {
            this.remarkColor = "red-remark-btn";
          } else {
            this.remarkColor = "default-remark-btn";
          }

          this.fetchOrderDetail();
        } else {
          this.$message.error(response.data.message || "保存备注失败");
        }
      } catch (error) {
        // 3. 补充Token无效/过期的错误处理（与项目统一逻辑对齐）
        if (error.response?.status === 401) {
          localStorage.removeItem("token"); // 清除无效Token
          this.$router.push("/MerchantLogin"); // 跳转商家登录页
          return; // 避免后续重复提示错误
        }

        // 更详细的错误处理
        console.error("提交备注失败:", error);
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          this.$message.error(`保存备注失败: ${error.response.data.message}`);
        } else {
          this.$message.error("保存备注失败，请检查网络连接或稍后重试");
        }
      }
    },

    // 显示隐藏买家信息
    toggleAddressDisplay() {
      this.showFullInfo = !this.showFullInfo;
    },
  },
};
</script>

<style scoped>
.order-detail-container {
  padding: 20px;
  background-color: #f5f7fa;
}

.header {
  margin-bottom: 20px;
}

.header h2 {
  margin: 0;
  color: #303133;
}

.action-bar {
  margin-bottom: 20px;
}

.action-btn {
  margin-right: 10px;
}

.order-content {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.top-section,
.middle-section {
  margin-bottom: 20px;
}

.info-section {
  padding: 20px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  height: 100%;
  box-sizing: border-box;
}

.bottom-section {
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  font-weight: bold;
  color: #303133;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
}

.info-content {
  min-height: 100px;
}

.info-content p {
  margin: 8px 0;
  color: #606266;
}

.fill-btn,
.remark-btn,
.toggle-btn {
  padding: 0;
}

.goods-image {
  width: 80px;
  height: 80px;
  border-radius: 4px;
}

.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
}

.goods-id {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}

.value {
  margin-right: 10px;
  color: #606266;
}

/* 添加上下布局样式 */
.vertical-layout {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.vertical-layout .fill-btn,
.vertical-layout .remark-btn {
  margin-top: 10px;
}

/* 调整备注内容样式 */
.remark-content {
  word-break: break-all;
  margin-bottom: 10px;
  color: #606266;
}

/* 快递单号容器样式 */
.express-number-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 10px;
}

.express-number-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 8px;
}

.express-actions {
  display: flex;
}

.copy-btn {
  color: #409eff;
  margin-left: 10px;
}

.copy-btn:hover {
  color: #66b1ff;
}

/* 备注按钮颜色样式 */
.red-remark-btn {
  color: #f56c6c !important;
}

.green-remark-btn {
  color: #67c23a !important;
}

.default-remark-btn {
  color: #606266 !important;
}

/* 备注弹窗样式 */
.remark-dialog-content {
  padding: 10px;
}

.tag-group {
  margin-bottom: 20px;
}

.tag-group-title {
  font-size: 14px;
  color: #606266;
  margin-bottom: 8px;
  font-weight: 500;
}

.remark-tag {
  margin-right: 10px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: all 0.3s;
}

.remark-tag:hover {
  opacity: 0.8;
}

.tag-selected {
  background-color: #409eff;
  color: white;
}

.remark-input-container {
  margin-bottom: 20px;
}

.dialog-buttons {
  text-align: right;
}

/* 快递单号弹窗样式 */
.express-dialog-content {
  padding: 20px;
}

.dialog-buttons {
  margin-top: 20px;
  text-align: right;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .order-detail-container {
    padding: 10px;
  }

  .top-section .el-col,
  .middle-section .el-col {
    margin-bottom: 15px;
  }

  .info-section {
    padding: 15px;
  }

  .express-number-container {
    flex-direction: column;
    align-items: flex-start;
  }

  .express-actions {
    margin-top: 10px;
  }
}

/* 动画效果 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* 按钮悬停效果 */
.action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

/* 表格样式优化 */
.el-table {
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

.el-table::before {
  height: 0;
}

/* 分页器样式优化 */
.pagination {
  padding: 15px 0;
}

/* 弹窗按钮样式优化 */
.dialog-footer .el-button {
  min-width: 80px;
}

/* 标签选中状态的动画 */
.tag-selected {
  transition: all 0.3s ease;
}

/* 备注内容区域样式优化 */
.remark-content {
  line-height: 1.6;
  padding: 8px;
  background-color: #f8f9fa;
  border-radius: 4px;
  margin-bottom: 10px;
}

/* 快递单号显示样式优化 */
.express-number {
  font-family: monospace;
  font-size: 14px;
  font-weight: bold;
  color: #409eff;
}

/* 操作按钮组样式 */
.action-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.action-buttons .el-button {
  margin: 0;
  padding: 8px 12px;
}

/* 表单元素样式优化 */
.el-input__inner,
.el-textarea__inner {
  border-radius: 4px;
}

/* 图片预览样式优化 */
.el-image {
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* 响应式表格处理 */
@media (max-width: 1200px) {
  .el-table {
    overflow-x: auto;
  }

  .el-table__body-wrapper {
    overflow-x: auto;
  }
}

/* 暗色模式支持 */
@media (prefers-color-scheme: dark) {
  .order-detail-container {
    background-color: #1a1a1a;
  }

  .order-content {
    background-color: #2d2d2d;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.3);
  }

  .info-section {
    border-color: #434343;
  }

  .section-header {
    border-bottom-color: #434343;
    color: #e6e6e6;
  }

  .info-content p {
    color: #bfbfbf;
  }

  .value {
    color: #bfbfbf;
  }

  .remark-content {
    background-color: #3a3a3a;
  }
}
</style>